import React from 'react';
import './TitreRegleUrb.css';

const TitreRegleUrb= () => {
    return (
        

        <div className='containerUrb'>
            

                <h2>Règles d'urbanisme</h2>
     
            </div>
            
           
    
    
    );
};

export default TitreRegleUrb;
